/**
 * @desc 工厂直发整柜订舱计划导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.cabinMasterFactoryWhole.exportCabinFactoryBookingPlanReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/exportCabinFactoryBookingPlanReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
